import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./HealthBenefits.css";

const cards = [
  {
    icon: <img src="/icons/tele.webp" alt="Efficiency" />,
    title: "TELEMEDICINE",
    desc: "Provides remote healthcare services through virtual consultations, remote monitoring, and digital communication between patients and healthcare professionals."
  },
  {
    icon: <img src="/icons/robot.webp" alt="Sustainability" />,
    title: "AI IN DIAGNOSTICS",
    desc: "Uses advanced algorithms and machine learning to analyze medical data and enhance diagnostic capabilities. It supports healthcare professionals in making informed decisions."
  },
  {
    icon: <img src="/icons/iomt.webp" alt="Engagement" />,
    title: "INTERNET OF MEDICAL THINGS(IOMT)",
    desc: "An interconnected network of medical devices and applications that collect, share, and analyze health data via wearable devices, sensors, and other IoTs to improve healthcare delivery."
  },
  {
    icon: <img src="/icons/dtc.webp" alt="Engagement" />,
    title: "DIRECT-TO-CONSUMER(DTC) HEALTHCARE",
    desc: "Provides healthcare services and products directly to consumers, enhancing convenience, accessibility, and personalized experiences. The integration of wearable devices and remote monitoring technologies enables continuous health tracking. Users can monitor vital signs, and share real-time health data with healthcare providers, fostering proactive healthcare management."
  }
];

export default function GreenBenefits({ imageSrc }) {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="green-benefits-section" id="benefits">
      <div className="container">
      <div className="green-benefits-top">
        <div className="green-benefits-text" data-aos="fade-right">
          <div className="green-benefits-title">
            DIGITAL ACCELERATION<br />
            <span className="green-benefits-title-blue">IN HEALTHCARE</span>
          </div>
          <div className="green-benefits-desc">
            In the ever-evolving landscape of healthcare, institutions are seeking advanced digital solutions to streamline processes and enhance patient outcomes. Our suite of health tech products is tailored to meet the unique challenges faced by healthcare providers. Our commitment to innovation drives the integration of new technologies into the healthcare sector, creating a more connected and efficient ecosystem.
          </div>
        </div>
        <div className="green-benefits-image" data-aos="fade-left">
          <img src={imageSrc} alt="Digital Acceleration" />
        </div>
      </div>
      <div className="green-benefits-cards">
        {cards.map((card, i) => (
          <div
            className="green-benefits-card"
            key={i}
            data-aos="fade-up"
            data-aos-delay={100 + i * 100}
          >
            <div className="green-benefits-card-icon">{card.icon}</div>
            <div className="green-benefits-card-title">{card.title}</div>
            <div className="green-benefits-card-desc">{card.desc}</div>
          </div>
        ))}
      </div>
      <div className="green-benefits-btn-row" data-aos="fade-up" data-aos-delay="500">
        <button className="green-benefits-btn">
          MORE ABOUT DIGITAL ACCELERATION
        </button>
      </div>
      </div>
    </section>
  );
}